import { parseUrl, stringifyUrl } from 'query-string';

export function setVariantUrlParam(variantId: number|null): void {
    const { url, query } = parseUrl(window.location.href);

    const newUrl = stringifyUrl({
        url,
        query: {
            ...query,
            variant: variantId,
        }
    }, {
        skipEmptyString: true,
        skipNull: true,
    });

    if (window.history) {
        window.history.replaceState({}, document.title, newUrl);
    }
}

export function getQuantityMax(selectedVariant: number|null, variants: string | null) {
    if (variants === null || selectedVariant === null) { return; }

    const variantMaxQtyObj = JSON.parse(variants);
    return (variantMaxQtyObj[selectedVariant]);
}

export function formatPrice(price: number|null, moneyFormat:string) {
    if (price == null) { return null; }
    const priceDecimal = String((price / 100).toFixed(2));
    let updatedPrice = moneyFormat.replace('{{amount}}', priceDecimal);
    updatedPrice = updatedPrice.replace('{{ amount }}', priceDecimal);

    return updatedPrice;
}
